export const DASHBOARD_BADGE_OPTIONS = [
  { key: "tasks", label: "Tasks", roles: ["admin", "project_manager", "field_lead", "technician", "accounting"] },
  { key: "reports", label: "Reports", roles: ["admin", "project_manager"] },
  { key: "accountingAlerts", label: "Accounting Alerts", roles: ["admin", "accounting"] },
  { key: "accounting", label: "Invoice Review", roles: ["admin", "accounting"] },
  { key: "deadlines", label: "Deadlines", roles: ["admin", "project_manager", "field_lead", "technician", "accounting"] },
];

export function filterSidebarBadges(badges = {}, preferences = {}) {
  return Object.fromEntries(
    Object.entries(badges).map(([key, count]) => [key, preferences[key] === false ? 0 : count]),
  );
}
